import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

// 支付宝授权
export const aliPayOauthToken = async (params: object) => {
  return await POST({
    url: Api.aliPayOauthToken,
    params: {
      ...params
    },
    showError: false
  })
}
